import React, { useState, useEffect, useRef } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate, useParams } from "react-router-dom";
import { BsDownload } from "react-icons/bs";
import { Container, Row, Col, Button, Spinner, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import html2canvas from "html2canvas";
import Loader from "../components/loader";
import jsPDF from "jspdf";
import "./prescription.css"; // Assuming you'll create this CSS file

const Prescription = () => {
  const [prescriptionData, setPrescriptionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const componentRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/prescription/view?consultation_id=${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch prescription data");
        }
        const data = await response.json();
        if (data.statusCode === 1 && data.payLoad) {
          setPrescriptionData(data.payLoad);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching prescription data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);
  const downloadPdf = async () => {
    try {
      const element = componentRef.current;
      
      // Add class to hide download section during PDF generation
      element.classList.add('pdf-capture');
      
      const canvas = await html2canvas(element, { 
        scrollY: -window.scrollY,
        scale: 2, // Higher quality
        useCORS: true
      });
      
      // Remove the class after capturing
      element.classList.remove('pdf-capture');
      
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgWidth = pdfWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
      pdf.save("prescription.pdf");
    } catch (error) {
      console.error("Error generating PDF", error);
      // Make sure to remove the class even if there's an error
      if (componentRef.current) {
        componentRef.current.classList.remove('pdf-capture');
      }
    }
  };
  return (
    <>
      <Navbar />
      <Container fluid className="prescription-container">
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "60vh" }}
          >
            <Loader type="selectedappointment" count={1} />
          </div>
        ) : (
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <Card ref={componentRef} className="prescription-card">
                {/* Header Section */}
                <div className="prescription-header">
                  <Row className="align-items-start">
                    <Col md={4}>
                      <div className="doctor-info d-flex flex-column">
                        <div className="doctor-name">
                          {prescriptionData?.DoctorFullName}
                        </div>
                        <div className="doctor-specialty">
                          {prescriptionData?.DoctorSpecialties}
                        </div>
                        <div className="clinic-info">
                          Helpline: 0344-3333737
                          <br />
                          support@webdoc.com.pk
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="logo-section text-center">
                        <img
                          src="/logob.png"
                          width={150}
                          alt="WebDoc Logo"
                          className="prescription-logo"
                        />
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="patient-info-right">
                        <div className="patient-detail">
                          <span className="patient-label">Patient Name :</span>
                          <span className="patient-value">
                            {prescriptionData?.PatientFirstName}
                          </span>
                        </div>
                        <div className="patient-detail">
                          <span className="patient-label">Date:</span>
                          <span className="patient-value">
                            {prescriptionData?.ConsultationDate}
                          </span>
                        </div>
                        <div className="patient-detail">
                          <span className="patient-label">Phone Number:</span>
                          <span className="patient-value">
                            {prescriptionData?.PatientPhone}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>{" "}
                {/* Medical Information */}
                <div className="content-section">
                  <Row className="medical-sections">
                    <Col md={6}>
                      {/* Complaint */}
                      <div className="section-block">
                        <div className="section-title">Complaint</div>
                        <div className="section-content">
                          {prescriptionData?.Complaint ||
                            "No complaint mentioned"}
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      {/* Diagnosis */}
                      <div className="section-block">
                        <div className="section-title">Diagnosis</div>
                        <div className="section-content">
                          {prescriptionData?.Diagnosis ||
                            "No diagnosis mentioned"}
                        </div>
                      </div>
                    </Col>
                    <Col md={12}>
                      {/* Tests */}
                      <div className="section-block">
                        <div className="section-title">Tests</div>
                        <div className="section-content">
                          {prescriptionData?.Tests || "No tests prescribed"}
                        </div>
                      </div>
                    </Col>

                    <Col md={12}>
                      {" "}
                      {/* Remarks */}
                      <div className="section-block">
                        <div className="section-title">Remarks</div>
                        <div className="section-content">
                          {prescriptionData?.Remarks || "No additional remarks"}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* Medicines Section */}
                <div className="medicines-section">
                  <div className="medicines-header">Medicines</div>
                  {prescriptionData?.Consultationdetails?.length > 0 ? (
                    prescriptionData.Consultationdetails.map(
                      (medication, index) => (
                        <div key={index} className="medication-item">
                          <div className="medicine-name">
                            {medication.MedicineName}
                          </div>

                          <div className="medication-simple-details">
                            <div>
                              <strong>Days:</strong> {medication.Days} days
                            </div>
                            <div>
                              <strong>Detail:</strong>{" "}
                              {["Morning", "Day", "Night"]
                                .filter((time) => medication[time])
                                .map(
                                  (time, idx, arr) =>
                                    `${time}: ${medication[time]}${
                                      idx < arr.length - 1 ? ", " : ""
                                    }`
                                )}
                            </div>
                          </div>

                          {medication.AdditionalNotes && (
                            <div className="medication-notes">
                              <strong>Instructions:</strong>{" "}
                              {medication.AdditionalNotes}
                            </div>
                          )}
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center text-muted py-4">
                      <p>No medications prescribed</p>
                    </div>
                  )}
                </div>
                {/* Download Section */}
                <div className="download-section">
                  <Button
                    onClick={downloadPdf}
                    className="download-btn"
                    size="lg"
                  >
                    <BsDownload className="me-2" />
                    Download Prescription PDF
                  </Button>
                </div>
              </Card>
            </Col>
          </Row>
        )}
      </Container>

      <div style={{ paddingTop: "100px" }}>
        <Footer />
      </div>
    </>
  );
};

export default Prescription;
